import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'


class EntrySuggestion extends Component {

  state = {
    id: 0,
    language_code: "",
    suggested_entry: "",
    created_for: "",
    vehicle_brand: "",
    creator: null,
    approved: false,
    createdAt: "",
    updatedAt: "",
  }

  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    // console.log(props.entrySuggestion.id+" is "+props.entrySuggestion.approved)
    this.state = { 
      id: props.entrySuggestion.id,
      language_code: props.entrySuggestion.language_code,
      created_for: props.entrySuggestion.created_for,
      vehicle_brand: props.entrySuggestion.vehicle_brand,
      creator: props.entrySuggestion.creator,
      suggested_entry: props.entrySuggestion.suggested_entry,
      createdAt: props.entrySuggestion.createdAt,
      updatedAt: props.entrySuggestion.updatedAt,
      approved: props.entrySuggestion.approved
    };
  }

  formatDate(date, isDateTime) {
    return new Intl.DateTimeFormat("de-DE", isDateTime ? {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
        hour:  "2-digit",
        minute: "2-digit",
       second: "2-digit"
    } : {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
    }).format(new Date(date))
  }
  
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    let elements = React.Children.toArray(this.props.children)
    let deleteButton
    let updateButton
    if(elements.length === 2){
      updateButton = React.cloneElement(elements[0], {id: this.state.id, state: this.state})
      deleteButton = React.cloneElement(elements[1], {id: this.state.id})
    }
    // console.log("Brand: " + this.state.vehicle_brand)
    return (
        <tr className={this.state.approved ? "tableApproved" : ""}>
            <td>{this.state.id}</td>
            <td>{this.state.language_code}</td>
            <td>{this.state.creator ? this.state.creator.id + " " + this.state.creator.fullname : "Deleted"}</td>
            <td>{token && !this.props.locked ?
                <input
                value={this.state.suggested_entry}
                onChange={e => this.setState({suggested_entry: e.target.value})}
                type="text"
                placeholder="suggested_entry"
                /> : this.state.suggested_entry}</td>
            <td>{this.state.created_for}</td>
            <td>{this.state.vehicle_brand !== null ? this.state.vehicle_brand.id + " " + this.state.vehicle_brand.name : "-"}</td>
            <td>{this.state.approved ? "true" : "false"}</td>
            <td>{this.formatDate(this.state.createdAt, true)}</td>
            <td>{this.formatDate(this.state.updatedAt, true)}</td>
            {token && !this.props.locked && <td>{ updateButton }</td>}
            {token && !this.props.locked && <td>{ deleteButton }</td>}
            
        </tr>
        )
    } 
    //{token && !this.props.locked && <td>{ deleteButton }</td>}

}

export default EntrySuggestion